import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import { logger } from '../../index';
import { TRACK_EVENT, TRACK_PAGE_VIEWED } from '../constants';
import { getTracker } from './initTracker';

var _getTracker = getTracker(),
    instance = _getTracker.instance;

export var trackPageViewActions = function trackPageViewActions(_ref) {
  var data = _extends({}, _ref);

  return instance.trackEvent({
    type: TRACK_PAGE_VIEWED,
    data: data
  });
};
export var trackEventActions = function trackEventActions(_ref2) {
  var action = _ref2.action,
      extraProps = _objectWithoutProperties(_ref2, ["action"]);

  if (!action) {
    logger.error('action for event type trackers is not defined.');
    return false;
  }

  return instance.trackEvent({
    type: TRACK_EVENT,
    action: action,
    data: _objectSpread({}, extraProps)
  });
};